/* eslint-disable global-require */
// eslint-disable-next-line import/prefer-default-export

// 空气站点类型选项
const iconsConfig = {
  star: {
    iconSize: [60,60,],
    topOffset: '2px',
    good: './static/data/icon/star/good_img.png',
    mild: './static/data/icon/star/mild_img.png',
    moderate: './static/data/icon/star/moderate_img.png',
    optimal: './static/data/icon/star/optimal_img.png',
    serious: './static/data/icon/star/serious_img.png',
    severe: './static/data/icon/star/severe_img.png',
    nodata: './static/data/icon/star/no_data_img.png',
  },
  bubble: {
    iconSize: [40,40,],
    good: './static/data/icon/country/good_img.png',
    mild: './static/data/icon/country/mild_img.png',
    moderate: './static/data/icon/country/moderate_img.png',
    optimal: './static/data/icon/country/optimal_img.png',
    serious: './static/data/icon/country/serious_img.png',
    severe: './static/data/icon/country/severe_img.png',
    nodata: './static/data/icon/country/no_data_img.png',
  },
  rectangle: {
    iconSize: [40,40,],
    good: './static/data/icon/province/good_img.png',
    mild: './static/data/icon/province/mild_img.png',
    moderate: './static/data/icon/province/moderate_img.png',
    optimal: './static/data/icon/province/optimal_img.png',
    serious: './static/data/icon/province/serious_img.png',
    severe: './static/data/icon/province/severe_img.png',
    nodata: './static/data/icon/province/no_data_img.png',
  },
  triangle: {
    iconSize: [40,40,],
    topOffset: '5px',
    good: './static/data/icon/city/good_img.png',
    mild: './static/data/icon/city/mild_img.png',
    moderate: './static/data/icon/city/moderate_img.png',
    optimal: './static/data/icon/city/optimal_img.png',
    serious: './static/data/icon/city/serious_img.png',
    severe: './static/data/icon/city/severe_img.png',
    nodata: './static/data/icon/city/no_data_img.png',
  },
  circle: {
    iconSize: [40,40,],
    good: './static/data/icon/micro/good_img.png',
    mild: './static/data/icon/micro/mild_img.png',
    moderate: './static/data/icon/micro/moderate_img.png',
    optimal: './static/data/icon/micro/optimal_img.png',
    serious: './static/data/icon/micro/serious_img.png',
    severe: './static/data/icon/micro/severe_img.png',
    nodata: './static/data/icon/micro/no_data_img.png',
  },
};

export const icons = {
  country: {
    // 默认配置数据
    ...iconsConfig.bubble,
  },
  province: {
    ...iconsConfig.rectangle,
  },
  city: {
    ...iconsConfig.triangle,
  },
  micro: {
    ...iconsConfig.circle,
  },
  cookingFume: {
    iconSize: [40,40,],
    disconnected: './static/data/icon/cookingFume/disconnected.png',
    high: './static/data/icon/cookingFume/mild.png',
    normal: './static/data/icon/cookingFume/optimal.png',
    excess: './static/data/icon/cookingFume/severe.png',
    abnormal: './static/data/icon/cookingFume/abnormal.png',
    nodata: './static/data/icon/cookingFume/optimal.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  cookingFumeList: {
    iconSize: [40,40,],
    disconnected: './static/data/icon/cookingFume/disconnected.png',
    high: './static/data/icon/cookingFume/mild.png',
    normal: './static/data/icon/cookingFume/optimal.png',
    excess: './static/data/icon/cookingFume/severe.png',
    abnormal: './static/data/icon/cookingFume/abnormal.png',
    nodata: './static/data/icon/cookingFume/optimal.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  company: {
    iconSize: [40,40,],
    disconnected: './static/data/icon/company/disconnected.png',
    high: './static/data/icon/company/mild.png',
    normal: './static/data/icon/company/optimal.png',
    excess: './static/data/icon/company/severe.png',
    nodata: './static/data/icon/company/optimal.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  companyList: {
    iconSize: [40,40,],
    disconnected: './static/data/icon/company/disconnected.png',
    high: './static/data/icon/company/mild.png',
    normal: './static/data/icon/company/optimal.png',
    excess: './static/data/icon/company/severe.png',
    nodata: './static/data/icon/company/optimal.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  construction: {
    iconSize: [40,40,],
    normal: './static/data/icon/construction/optimal.png',
    nodata: './static/data/icon/construction/optimal.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  constructionList: {
    iconSize: [40,40,],
    normal: './static/data/icon/construction/optimal.png',
    nodata: './static/data/icon/construction/optimal.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  yard: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/yard_normal.png',
    disconnected: './static/data/icon/others/yard_disconnected.png',
    nodata: './static/data/icon/others/yard_disconnected.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  yardList: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/yard_normal.png',
    disconnected: './static/data/icon/others/yard_disconnected.png',
    nodata: './static/data/icon/others/yard_disconnected.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  park: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/park_normal.png',
    disconnected: './static/data/icon/others/park_disconnected.png',
    nodata: './static/data/icon/others/park_disconnected.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  parkList: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/park_normal.png',
    disconnected: './static/data/icon/others/park_disconnected.png',
    nodata: './static/data/icon/others/park_disconnected.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  muckParkList: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/park_normal.png',
    disconnected: './static/data/icon/others/park_disconnected.png',
    nodata: './static/data/icon/others/park_disconnected.png',

    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  repair: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/repair_normal.png',
    disconnected: './static/data/icon/others/repair_disconnected.png',
    nodata: './static/data/icon/others/repair_disconnected.png',
    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  repairList: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/repair_normal.png',
    disconnected: './static/data/icon/others/repair_disconnected.png',
    nodata: './static/data/icon/others/repair_disconnected.png',
    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  muckTrack: {
    size: [40, 32,],
    iconSize: [40, 32,],
    licenseSize: [62, 20,],
    start: './static/data/icon/car.png',
    normal: './static/data/icon/carbg2.png',
    license: './static/data/icon/carbg.png',
  },
  moveTrack: {
    size: [40, 32,],
    iconSize: [40, 32,],
    licenseSize: [62, 20,],
    start: './static/data/icon/car.png',
    normal: './static/data/icon/carbg2.png',
    license: './static/data/icon/carbg.png',

    good: './static/data/icon/province/good_img.png',
    mild: './static/data/icon/province/mild_img.png',
    moderate: './static/data/icon/province/moderate_img.png',
    optimal: './static/data/icon/province/optimal_img.png',
    serious: './static/data/icon/province/serious_img.png',
    severe: './static/data/icon/province/severe_img.png',
    nodata: './static/data/icon/province/no_data_img.png',
  },
  fogGunTrack: {
    size: [40, 32,],
    iconSize: [40, 32,],
    licenseSize: [62, 20,],
    start: './static/data/icon/sprayLabelsLayer.png',
    normal: './static/data/icon/carbg1.png',
    license: './static/data/icon/carbg.png',
  },
  wateringTrack: {
    size: [40, 32,],
    iconSize: [40, 32,],
    licenseSize: [62, 20,],
    start: './static/data/icon/waterLabelsLayer.png',
    normal: './static/data/icon/carbg1.png',
    license: './static/data/icon/carbg.png',
  },
  sweeperTruck: {
    size: [40, 32,],
    iconSize: [40, 32,],
    licenseSize: [62, 20,],
    start: './static/data/icon/cleanLabelsLayer.png',
    normal: './static/data/icon/carbg1.png',
    license: './static/data/icon/carbg.png',
  },
  cluster: {
    iconSize: [44,44,],
    good: './static/data/icon/good_aqi_img.png',
    mild: './static/data/icon/mild_aqi_img.png',
    moderate: './static/data/icon/moderate_aqi_img.png',
    optimal: './static/data/icon/optimal_aqi_img.png',
    serious: './static/data/icon/serious_aqi_img.png',
    severe: './static/data/icon/severe_aqi_img.png',
    nodata: './static/data/icon/no_data_aqi_img.png',

    // 餐饮、企业等其他源他源状态对应图标
    disconnected: './static/data/icon/no_data_aqi_img.png',
    high: './static/data/icon/high_img.png',
    normal: './static/data/icon/normal_img.png',
    excess: './static/data/icon/moderate_aqi_img.png',
    abnormal: './static/data/icon/mild_aqi_img.png',
  },
  pre: {
    iconSize: [36,36,],
    good: './static/data/icon/pre/good_pre_img.png',
    mild: './static/data/icon/pre/mild_pre_img.png',
    moderate: './static/data/icon/pre/moderate_pre_img.png',
    optimal: './static/data/icon/pre/optimal_pre_img.png',
    severe: './static/data/icon/pre/severe_pre_img.png',
    nodata: './static/data/icon/pre/nodata_pre_img.png',
  },
  prs: {
    iconSize: [36,36,],
    valueColor: '#fff',
    good: './static/data/icon/prs/good_prs_img.png',
    mild: './static/data/icon/prs/mild_prs_img.png',
    moderate: './static/data/icon/prs/moderate_prs_img.png',
    optimal: './static/data/icon/prs/optimal_prs_img.png',
    severe: './static/data/icon/prs/severe_prs_img.png',
    nodata: './static/data/icon/prs/nodata_prs_img.png',
  },
  rhu: {
    iconSize: [36,36,],
    valueColor: '#fff',
    good: './static/data/icon/rhu/good_rhu_img.png',
    mild: './static/data/icon/rhu/mild_rhu_img.png',
    moderate: './static/data/icon/rhu/moderate_rhu_img.png',
    optimal: './static/data/icon/rhu/optimal_rhu_img.png',
    severe: './static/data/icon/rhu/severe_rhu_img.png',
    nodata: './static/data/icon/rhu/nodata_rhu_img.png',
  },
  tem: {
    iconSize: [36,36,],
    hot: './static/data/icon/tem/hot_tem_img.png',
    summer: './static/data/icon/tem/summer_tem_img.png',
    serious: './static/data/icon/tem/serious_tem_img.png',
    severe: './static/data/icon/tem/severe_tem_img.png',
    moderate: './static/data/icon/tem/moderate_tem_img.png',
    mild: './static/data/icon/tem/mild_tem_img.png',
    good: './static/data/icon/tem/good_tem_img.png',
    optimal: './static/data/icon/tem/optimal_tem_img.png',
    nodata: './static/data/icon/tem/nodata_tem_img.png',
  },
  satellitePoint: {
    iconSize: [45,47,],
    iconSizeHigh: [45,49,],
    normal: './static/data/icon/strawBurn/satelliteFireLayer.png',
    disconnected: './static/data/icon/strawBurn/satelliteFireLayer.png',
    nodata: './static/data/icon/strawBurn/satelliteFireLayer.png',
    high: './static/data/icon/strawBurn/satelliteFireLayerActive.png',
    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  monitorPoint: {
    iconSize: [45,47,],
    iconSizeHigh: [45,49,],
    normal: './static/data/icon/strawBurn/monitorFireLayer.png',
    disconnected: './static/data/icon/strawBurn/monitorFireLayer.png',
    nodata: './static/data/icon/strawBurn/monitorFireLayer.png',
    high: './static/data/icon/strawBurn/monitorFireLayerActive.png',
    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  strokePoint: {
    iconSize: [40, 40,],
    iconSizeHigh: [52, 52,],
    disconnected: './static/data/icon/warn/1.png',
    high: './static/data/icon/warn/2.png',
    abnormal: './static/data/icon/warn/3.png',
    normal: './static/data/icon/warn/4.png',
    excess: './static/data/icon/warn/5.png',
    warn: './static/data/icon/warn/6.png',
    worst: './static/data/icon/warn/7.png',
    nodata: './static/data/icon/strawBurn/monitorFireLayer.png',
    zoomSize: 12,
  },
  boiler: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/boiler_normal.png',
    disconnected: './static/data/icon/others/boiler_disconnected.png',
    nodata: './static/data/icon/others/boiler_disconnected.png',
    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  boilerList: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/boiler_normal.png',
    disconnected: './static/data/icon/others/boiler_disconnected.png',
    nodata: './static/data/icon/others/boiler_disconnected.png',
    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  furnace: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/furnace_normal.png',
    disconnected: './static/data/icon/others/furnace_disconnected.png',
    nodata: './static/data/icon/others/furnace_disconnected.png',
    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  furnaceList: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/furnace_normal.png',
    disconnected: './static/data/icon/others/furnace_disconnected.png',
    nodata: './static/data/icon/others/furnace_disconnected.png',
    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
  oilList: {
    iconSize: [40,40,],
    normal: './static/data/icon/others/oil_normal.png',
    disconnected: './static/data/icon/others/oil_disconnected.png',
    nodata: './static/data/icon/others/oil_disconnected.png',
    fontColor: '#e3e7eb',
    strokeColor: '#2f3239',
    zoomSize: 17,
  },
};

// 空气质量等级对应颜色，与地图图标图片颜色保持一致
export const colorMap = {
  serious: { bgColor: '#7e0100', },
  severe: { bgColor: '#810180', },
  moderate: { bgColor: '#ff0000', },
  mild: { bgColor: '#ff7d00', },
  good: { bgColor: '#fffd05', },
  optimal: { bgColor: '#00e700', },
};

export const updateIconsConfig = (key:string,type:string) :void => {
  icons[key] = { ...iconsConfig[type], };
};
